import { render } from "./ModalMatchesList.vue?vue&type=template&id=143d4d31&scoped=true"
import script from "./ModalMatchesList.vue?vue&type=script&lang=js"
export * from "./ModalMatchesList.vue?vue&type=script&lang=js"

import "./ModalMatchesList.vue?vue&type=style&index=0&id=143d4d31&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-143d4d31"

export default script